import hljs from 'highlight.js'
import { memo, useEffect, useRef } from 'react'
import type { ColorScheme } from '../../types'
// TODO: We should be using css ?inline vite import to get the string from the .css file. Unfortunately, this is not working. As a workaround, we are using the string directly.
import { CodeHighlighterDarkDiv } from './CodeHighlighterDark'
import { CodeHighlighterLightDiv } from './CodeHighlighterLight'

// FIX-ME: This is poorly implemented. The intention is to be a hotfix for react-highlight lib issues. This should be refactored.
export const CodeHighlighter = memo(
  ({
    children,
    language,
    colorSchemeName
  }: {
    children: string
    language: string
    colorSchemeName: ColorScheme
  }) => {
    const codeRef = useRef<HTMLElement | null>(null)

    const StyledDiv = colorSchemeName === 'dark' ? CodeHighlighterDarkDiv : CodeHighlighterLightDiv

    useEffect(() => {
      if (!codeRef.current) {
        return
      }

      hljs.highlightBlock(codeRef.current)
    }, [children, language])

    return (
      <StyledDiv>
        <pre
          style={{
            backgroundColor: colorSchemeName === 'dark' ? 'rgb(23 23 23)' : '#fff',
            border: `1px solid ${colorSchemeName === 'dark' ? '#292929' : 'rgb(227 227 227)'}`,
            borderRadius: '10px',
            padding: '12px'
          }}
        >
          <code ref={codeRef} className={language}>
            {children}
          </code>
        </pre>
      </StyledDiv>
    )
  }
)
